// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'search-solid';

export const Component = () => (
  <>
    <path d='M10.01 0C7.28 0 4.932.958 2.97 2.921 1.006 4.884 0 7.28 0 10.01c0 2.778 1.005 5.125 2.97 7.089 1.964 1.964 4.31 2.97 7.04 2.97 2.777 0 5.124-1.006 7.088-2.97 1.964-1.964 2.92-4.31 2.92-7.089 0-2.73-.957-5.124-2.92-7.088C15.134.957 12.788 0 10.009 0Zm0 .958c2.538 0 4.645.862 6.417 2.634 1.773 1.773 2.635 3.928 2.635 6.418 0 2.538-.862 4.645-2.635 6.418-1.772 1.773-3.88 2.634-6.418 2.634-2.49 0-4.597-.861-6.37-2.634-1.77-1.773-2.68-3.88-2.68-6.418 0-2.49.91-4.645 2.682-6.418C5.412 1.82 7.52.958 10.01.958Zm5.795 9.052c0 1.58-.575 2.921-1.677 4.023-1.101 1.149-2.49 1.724-4.071 1.724-1.58 0-2.921-.575-4.023-1.724-1.101-1.102-1.676-2.442-1.676-4.023 0-1.58.575-2.92 1.676-4.07 1.102-1.103 2.443-1.678 4.023-1.678 1.58 0 2.97.576 4.071 1.677 1.102 1.15 1.677 2.49 1.677 4.071Z' />
    <path d='M23.946 24.426a.54.54 0 0 1-.383-.144l-6.944-6.945c-.24-.239-.24-.478 0-.718.239-.24.479-.24.718 0l6.945 6.944c.24.24.24.48 0 .719a.434.434 0 0 1-.335.144Z' />
  </>
);

export const viewBox = '0 0 25 25';
